import { render, staticRenderFns } from "./SanityBlockBreak.vue?vue&type=template&id=f83a4ef6"
import script from "./SanityBlockBreak.vue?vue&type=script&lang=js"
export * from "./SanityBlockBreak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports